import { render, staticRenderFns } from "./SalaAulaSideBar.vue?vue&type=template&id=8e0bc12c&scoped=true"
import script from "./SalaAulaSideBar.vue?vue&type=script&lang=js"
export * from "./SalaAulaSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0bc12c",
  null
  
)

export default component.exports